// Contents for /guide: kanji, full title, short label for the step strip, typical time.
const SECTIONS = [
    [
        '規',
        'The 25-year rule',
        '25-year rule',
        'before'
    ],
    [
        '代',
        'Choosing an export agent',
        'Agent',
        'before'
    ],
    [
        '査',
        'Reading an auction sheet',
        'Sheet',
        'days'
    ],
    [
        '札',
        'Bidding and fees',
        'Bid',
        'auction day'
    ],
    [
        '金',
        'Paying: Wise or wire',
        'Pay',
        '1–3 days'
    ],
    [
        '輸',
        'Export & RoRo shipping',
        'Ship',
        '3–6 wks'
    ],
    [
        '関',
        'Customs: 7501, duty, MPF, HMF',
        'Customs',
        '1–2 wks'
    ],
    [
        '引',
        'Port pickup & trucking',
        'Pickup',
        '~1 wk'
    ],
    [
        '登',
        'Title and registration',
        'Title',
        'varies'
    ]
];
export const TOC = SECTIONS.map(([k, title, short, time], i)=>({
        n: String(i + 1).padStart(2, '0'),
        k,
        title,
        short,
        time,
        href: `#s${i + 1}`
    }));
// Japan-side fees from one real five-vehicle shipment (Aug 2026).
export const JP_FEES = [
    [
        'Hammer price',
        'winning bid'
    ],
    [
        'Agent service fee',
        '¥100,000 flat'
    ],
    [
        'Auction fee',
        '¥18,000–22,000'
    ],
    [
        'Inland transport to port',
        '¥11,800–34,200'
    ],
    [
        'Insurance',
        '¥9,000–12,000'
    ],
    [
        'RoRo freight (kei, ~9 m³)',
        '¥167,935–176,684'
    ]
];
